<template>
    <div class="card no-shadow m-l-12">
        <div class="card-content p-x-0 padding-top-0">
            <div v-if="!fetching_invoices" v-resultsCount="items.length"></div>

            <div class="content">
                    <div class="level" v-if="!fetching_invoices">
                        <table class="table is-size-7-touch is-marginless is-fullwidth transparent-table">
                            <thead>
                                <tr>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Date</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Description</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Reference</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Invoice type</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Status</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Amount</td>
                                    <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey">Date paid</td>
                                    <td class="is-narrow has-text-weight-bold"></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!fetching_invoices && !items.length">
                                    <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="8">
                                        <p class="has-text-centered is-padded-20">No invoices found for business.</p>
                                    </td>
                                </tr>
                                <tr v-else v-for="(invoice, index) in items" :key="index">
                                    <td class="is-size-7">{{ invoice.created_at_date }}</td>
                                    <td class="is-size-7"><span>{{ getDescription(invoice, 'admin') }}</span></td>
                                    <td class="is-size-7 is-narrow">
                                        <span v-if="invoice.payment_status === 'PAID'">{{ invoice.tax_number }}</span>
                                        <span v-else>{{ invoice.payment_reference }}</span>
                                    </td>
                                    <td class="is-desktop is-size-7-mobile is-size-7-touch">
                                        <span v-if="invoice.payment_status === 'PAID'">Tax invoice</span>
                                        <span v-if="invoice.payment_status === 'PENDING'">Pro forma</span>
                                    </td>
                                    <td class="is-size-7 is-narrow">{{invoice.payment_status}}</td>
                                    <td class="is-size-7 is-narrow"><span>R{{ getPrice(invoice)}}</span></td>
                                    <td class="is-size-7">
                                        <span v-if="invoice.payment_status === 'PENDING'">Awaiting pmt</span>
                                        <span v-else-if="invoice.payment_status === 'PAID'">{{invoice.updated_at_date}}</span>
                                        <span v-else>&nbsp;</span>
                                    </td>
                                    <td>
                                        <div class="buttons is-pulled-right">
                                            <a class="has-text-underlined color-2aabe1 is-hidden-mobile is-size-7-mobile" :href="`${api_url}/invoices/${invoice.id}/file`">
                                                DOWNLOAD
                                            </a>
                                            <a :href="`${api_url}/invoices/${invoice.id}/file`"
                                               class="button-mobile-table is-button-blue is-hidden-desktop circle-border is-hidden-desktop is-hidden-tablet is-hidden-widescreen">
                                                <i class="fas fa-download"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            <!-- paginator -->
            <paginator :dataSet="dataSet" @changed="getInvoices"></paginator>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import misc from '../../mixins/misc.js'
  import Paginator from '../../components/Paginator.vue'

  export default {
    mixins: [misc],
    components: {
      Paginator
    },
    data () {
      return {
        fetching_invoices: false,
        items: [],
        api_url: process.env.API_URL,
        invoices: {},
        total_records: 0,
        dataSet: {}
      }
    },
    computed: {
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      }
    },
    created () {
      this.getInvoices(1)
    },
    methods: {
      /**
       * Makes an api call to get invoices for org
       * @param {number | null} page to return data from
       * @returns {void}
       */
      getInvoices (page) {
        this.invoices = {}
        this.fetching_invoices = true
        axios.get(this.url(page))
          .then((invoices) => {
            this.fetching_invoices = false
            this.refresh(invoices)
            window.scrollTo(0, 0)
          })
          .catch(() => {
            this.fetching_invoices = false
          })
      },
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }
        return `/${this.getBusinessSlug}/billing-history?for=admin&page=${page}`
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessInvoices.vue